import DefaultList from "@Common/DefaultList";
import { useNavigationHandler } from "@hook";
import { getStatusTag, handleCopyBuffer } from "@utils";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";

const OfferList = inject("mainStore")(
    observer(({ mainStore }) => {
        const managers = computed(() => mainStore.getMainStore("suggest.managers_suggest")).get();
        const navigation = useNavigationHandler();

        if (!managers?.length) return;

        const handleRowClick = (e) => {
            mainStore.setMainStore("detailData", {});
            navigation(e.originalEvent, `/offers/${e.data._id}`);
        };

        return (
            <DefaultList
                dataKey="promo_vendor"
                apiUrl="/promo/vendors"
                keysToGet={["_id", "name", "squareLogo", "active", "archived", "draft", "risManagerId"]}
                titleName="Вендор"
                keyFilterSearch="name"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={[
                    {
                        field: "_id",
                        header: "ID",
                        style: { width: "10%", maxWidth: "300px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                    },
                    {
                        field: "name",
                        header: "Название",
                        body: (item) => <span className="list__name">{item.name}</span>,
                        style: { width: "300px", maxWidth: "300px" },
                        sortable: true,
                    },
                    {
                        field: "risManagerId",
                        header: "Ответственный",
                        body: (item) => {
                            const manager = item.risManagerId ? managers?.find((m) => m._id === item.risManagerId) : false;
                            return <span className="list__name">{manager?.fullName || "-"}</span>;
                        },
                        style: { maxWidth: "350px", overflow: "hidden" },
                    },
                    {
                        body: (item) => (item.squareLogo ? <img src={item.squareLogo} alt={item.image} style={{ width: "35px", borderRadius: "6px", height: "35px" }} /> : <Skeleton size="49px"></Skeleton>),
                        header: "Логотип",
                        style: { width: "10%", padding: "2px" },
                    },
                    {
                        body: (item) => {
                            const tag = getStatusTag(item);
                            return <Tag severity={tag.type} icon={tag.icon} />;
                        },
                        header: "Статус",
                        style: { width: "1%" },
                        sortable: false,
                    },
                ]}
            />
        );
    }),
);

export default OfferList;
